import { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface SectionDetailsProps {
  details: {
    name: string;
    value: string | number;
  }[];
}

const SectionDetails: FC<SectionDetailsProps> = ({ details }) => {
  return (
    <Box mt={3}>
      <Box display="grid" gap={3}>
        {details.map((attribute) => (
          <Box key={`attribute-${attribute.name}`}>
            <Typography variant="subtitle1">{attribute.name}</Typography>
            <Typography variant="h5">{attribute.value}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SectionDetails;
